// --- UPDATED FILE: packages/api-client/src/services/public/cmsService.ts ---

import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type {
  PageDocument,
  PublicPageDocument,
  CmsComponentDocument,
  CmsRouteInfo,
  ServiceResponse,
} from '@dopomogai/types';

const PUBLIC_CMS_PREFIX = '/cms';

export const cmsService = {
  /**
   * Fetches a page document by its unique namespace.
   * @param namespace The unique ID of the document (e.g., 'home-page').
   * @param locale Optional locale for public content (e.g., 'en'). If provided, returns a PublicPageDocument.
   */
  getDocument: (namespace: string, locale?: string): ServiceResponse<PageDocument | PublicPageDocument> => {
    const params = locale ? { locale } : {};
    // Uses the corrected backend endpoint path
    return getApiClient().get<PageDocument | PublicPageDocument>(`${PUBLIC_CMS_PREFIX}/${namespace}`, { params })
      .then((response) => response.data)
      .catch((err) => handleApiError(err, `fetching document '${namespace}'`));
  },

  /**
   * Fetches the list of all available page routes for dynamic routing in the frontend.
   */
  listAllRoutes: (): ServiceResponse<CmsRouteInfo[]> => {
    // Uses the corrected backend endpoint path for listing routes
    return getApiClient().get<CmsRouteInfo[]>(`${PUBLIC_CMS_PREFIX}/`)
      .then((response) => response.data)
      .catch((err) => handleApiError(err, 'fetching all routes'));
  },

  /**
   * Fetches a raw component document (like a header or footer) by its namespace.
   */
  getComponent: (namespace: string): ServiceResponse<CmsComponentDocument> => {
    return getApiClient().get<CmsComponentDocument>(`${PUBLIC_CMS_PREFIX}/component/${namespace}`)
      .then((response) => response.data)
      .catch((err) => handleApiError(err, `fetching component document '${namespace}'`));
  },
};